"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultNumberConfig = void 0;
/**
 * The default number configuration.
 * Example: 22,000.00
 */
exports.defaultNumberConfig = {
    decimalSeparator: '.',
    decimalPrecision: 2,
    thousandsSeparator: ',',
    nonNumberPlaceholder: ''
};
//# sourceMappingURL=number.js.map